import moment from 'moment'
import React from 'react'
import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from '../../request'
import PDFFileView from '../DocumentViews/PDFFileView'
import { connect } from 'react-redux'
const Option = Select.Option

@Form.create()
class EditUniversity extends React.Component {
    state = {
        visible: true,
        childrenDrawer: true,
        adId: '',
        leads: [],
        file: '',
        arr: [],
        ext: null,
        linkUrl: null,
        loading: false,
        excelFieldArray: [],
        excelDatas: [],
        isAggrementExpire: false,
        paymentUpload: [],
        DBFieldsArray: [
            "studentName", 'status', "mode", "selectInquiryType", "dateOfBirth", "gender", "mobile", "watsupp", "emailId", "facebookEmail", "whichYearPlanningToGo", "enqType", "location", "caseHistory", "preference"
        ],
        fieldMappingArray: {},
        statusList: '',
        coursedata: '',
        oldUniversityId: '',
        inputTypes: {
            fields: [
                {
                    label: 'University',
                    key: 'universityInstitutionName',
                    disabled: true,
                    required: true,
                },
                {
                    label: 'Status',
                    key: 'universityStatus',
                    type: 'select',
                    options: ['Active', 'Block', 'Expired', 'Draft'],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            universityStatus: v
                        })
                    }
                },
                {
                    label: 'Expiry',
                    key: 'enrollmentExpiry',
                    type: 'date',
                    width: 500,
                    required: true,
                    format: 'DD-MMM-YYYY',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            enrollmentExpiry: v
                        })
                    }
                },
                {
                    label: 'Agreement Expiry?',
                    key: 'isAgreementExpire',
                    type: 'switch',
                    onChange: checked => {
                        this.props.form.setFieldsValue({ isAgreementExpire: checked }, () => {
                            this.updateSwitch(checked)
                        })
                    }
                },
                {
                    label: 'Renewal',
                    key: 'enrollmentRenewal',
                    type: 'date',
                    width: 500,
                    hidden: true,
                    required: false,
                    format: 'DD-MMM-YYYY',
                    onChange: v => {
                        this.props.form.setFieldsValue({ enrollmentRenewal: v })
                    }
                },
                {
                    label: 'Category',
                    key: 'universityCategory',
                    type: 'select',
                    width: 500,
                    options: ['Government', 'Private', 'Not Specified', 'SPP', 'IPP', 'SVP'],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ universityCategory: v })
                    }
                },
                {
                    label: 'Partnership',
                    key: 'universityPartnership',
                    type: 'select',
                    width: 500,
                    options: [],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ universityPartnership: v })
                    }
                },
                {
                    label: 'Training',
                    key: 'training',
                    type: 'select',
                    options: [{ id: 'True', display: 'Yes' }, { id: 'False', display: 'No' }],
                    required: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({ training: v })
                    }
                },
                {
                    label: 'PAYMENT Guidelines Document',
                    key: 'paymentUpload',
                    type: 'file',
                    required: true
                }


            ]
        }
    }


    setFormValue = () => {
        const { form, data, partnershipArr } = this.props;
        let inputTypes = this.state.inputTypes
        let partnerships = []
        _.each(partnershipArr, (item) => {
            partnerships.push({ _id: item.partnershipName, display: item.partnershipName })
        })
        inputTypes["fields"][5].options = partnerships
        setTimeout(() => {
            this.setState({ paymentUpload: data.paymentUpload, inputTypes: inputTypes }, () => {
                this.updateSwitch(data.isAgreementExpire)
            })
            form.setFieldsValue({
                ...data,
                enrollmentExpiry: moment(data.enrollmentExpiry),
                enrollmentRenewal: moment(data.enrollmentRenewal)
            })
        }, 500)

    }

    updateSwitch = (checked) => {
        let inputTypes = this.state.inputTypes
        inputTypes['fields'][4].hidden = checked ? false : true
        inputTypes['fields'][4].required = checked ? true : false
        this.setState({ inputTypes })

    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    viewPDF = e => {
        const { form, data, partnershipArr } = this.props;
        const { paymentUpload } = data;
        if (paymentUpload.length > 0) {
            let linkUrl = API_URL + paymentUpload[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }

    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    componentDidMount() {
        this.setFormValue()
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        e.preventDefault();
        const { form, courseId, data } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values._id = data._id
                delete values.universityInstitutionName;
                let x = await Request.updateUniversityAgreement(values)
                if (!x.error) {
                    this.onClose()
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }

        })
    }

    render() {

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const { visible, inputTypes } = this.state
        var ext = this.state.ext;
        var linkUrl = this.state.linkUrl;
        var paymentUpload = this.state.paymentUpload;
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Edit University
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}>
                <Card>
                    {
                        ext != null && paymentUpload.length > 0 ?
                            <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                            : null
                    }
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div>
                            <GetAllFormFields
                                apiurl={LAPI_URL}
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row>
                            <Col span={24}>
                                <Button onClick={this.viewPDF}>
                                    View Agreement
                                </Button>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditUniversity)
